import { Storage } from "@core-ui/helpers/Storage";
import { CART_TIMER_CLOSING_TIME, CART_TIMER_DURATION_TIME } from "../constants/TimerOnCart";

export const setTimerWidgetDurationInStorage = (closeDurationInSeconds: number): void => {
    Storage.setItem(CART_TIMER_DURATION_TIME, `${closeDurationInSeconds}`);
};

export const getTimerWidgetDurationFromStorage = (): number => {
    const durationTimeInSeconds = Number(Storage.getItem(CART_TIMER_DURATION_TIME, -1));
    return durationTimeInSeconds;
};

export const setTimerWidgetClosingTime = (closeTime: number, durationInSeconds: number): void => {
    const durationInSecondsFromStorage = getTimerWidgetDurationFromStorage();
    if (durationInSecondsFromStorage !== durationInSeconds) {
        Storage.setItem(CART_TIMER_CLOSING_TIME, `${closeTime}`);
        setTimerWidgetDurationInStorage(durationInSeconds);
    }
};

export const getClosingTimeEpochFromStorage = (): number => {
    const closingTime = Number(Storage.getItem(CART_TIMER_CLOSING_TIME, 0));
    return closingTime;
};

export const getClosingTime = (): number => {
    const closingTime = Number(Storage.getItem(CART_TIMER_CLOSING_TIME, 0));
    if (closingTime <= Date.now()) return 0;
    return Math.round((closingTime - Date.now()) / 1000);
};

export const closingTimeExist = (): boolean => {
    const closingTime = Number(Storage.getItem(CART_TIMER_CLOSING_TIME, 0));
    return closingTime !== 0;
};

export const clearTimerFromStorage = (): void => {
    try {
        Storage.removeItem(CART_TIMER_CLOSING_TIME);
        Storage.removeItem(CART_TIMER_DURATION_TIME);
    } catch {
        // no-op
    }
};
